import { useLayoutEffect as useLayoutEffect } from 'react';
import {
  invoke3e9ytlmskvi4s as invoke,
  invoke2ywiw9ln9yogo as invoke_0,
} from './raw/EffectHook.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function useLayoutEffectOnce(effect) {
  var tmp = useLayoutEffect;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  invoke(tmp, effect, tmp$ret$0);
}
function useLayoutEffect_0(effect) {
  invoke_0(useLayoutEffect, effect);
}
//region block: exports
export {
  useLayoutEffectOnce as useLayoutEffectOnce29bdczj7e3dte,
  useLayoutEffect_0 as useLayoutEffectd6pds3ouku61,
};
//endregion

//# sourceMappingURL=useLayoutEffect.mjs.map
